const EL_SALVADOR = "El Salvador";

export default {
  computed: {
    districtCatalog() {
      return this.getCatalogMH ? this.getCatalogMH("Distrito") || [] : [];
    },
    districtOptions() {
      return (this.districtCatalog || []).map((item) => ({
        ...item,
        DistritoKey: item.DistritoKey || `${item.Departamento}-${item.Municipio}-${item.Codigo}`,
        label: [item.Valores, item.MunicipioNombre || item.Municipio].filter(Boolean).join(" - "),
      }));
    },
  },
  methods: {
    isElSalvadorCountry(country) {
      return String(country || "").trim() === EL_SALVADOR;
    },
    getDistrictOptions(country, department, municipality) {
      if (!this.isElSalvadorCountry(country)) return [];

      const hasDepartment = department !== null && department !== undefined && String(department).trim() !== "";
      const hasMunicipality = municipality !== null && municipality !== undefined && String(municipality).trim() !== "";

      let options = [...(this.districtOptions || [])];

      if (hasDepartment) {
        options = options.filter((item) => String(item.Departamento) === String(department));
      }

      if (hasMunicipality) {
        options = options.filter((item) => String(item.Municipio) === String(municipality));
      }

      return options;
    },
    getDistrictByCode(code) {
      return (this.districtOptions || []).find((item) => {
        return String(item.DistritoKey) === String(code) || String(item.Codigo) === String(code);
      });
    },
    compareDistrictValue(selectedValue, itemValue) {
      const selected = selectedValue === null || selectedValue === undefined ? "" : String(selectedValue);
      const candidate = itemValue === null || itemValue === undefined ? "" : String(itemValue);

      if (!selected || !candidate) {
        return selected === candidate;
      }

      if (selected === candidate) {
        return true;
      }

      const selectedCode = selected.split("-").pop();
      const candidateCode = candidate.split("-").pop();
      return selectedCode !== "" && selectedCode === candidateCode;
    },
    getDistrictByGeoCodes(department, municipality, districtCode) {
      const normalizedDepartment = String(department || "");
      const normalizedMunicipality = String(municipality || "");
      const normalizedDistrict = String(districtCode || "");

      return (this.districtOptions || []).find((item) => {
        return (
          String(item.Departamento) === normalizedDepartment &&
          String(item.Municipio) === normalizedMunicipality &&
          String(item.Codigo) === normalizedDistrict
        );
      });
    },
    normalizeDistrictSelection(target, countryKey, departmentKey, municipalityKey, districtKey) {
      if (!target || !this.isElSalvadorCountry(target[countryKey])) return;

      const currentDistrict = target[districtKey];
      if (!currentDistrict) return;
      if (String(currentDistrict).includes("-")) return;

      const district = this.getDistrictByGeoCodes(
        target[departmentKey],
        target[municipalityKey],
        currentDistrict
      );

      if (district?.DistritoKey) {
        target[districtKey] = district.DistritoKey;
      }
    },
    onSalvadorDepartmentChange(target, countryKey, departmentKey, municipalityKey, districtKey) {
      if (!target) return;
      if (!this.isElSalvadorCountry(target[countryKey])) return;

      if (!target[departmentKey]) {
        target[municipalityKey] = "";
        target[districtKey] = "";
        return;
      }

      target[municipalityKey] = "";
      target[districtKey] = "";
    },
    onSalvadorMunicipalityChange(target, countryKey, municipalityKey, districtKey) {
      if (!target) return;
      if (!this.isElSalvadorCountry(target[countryKey])) return;

      if (!target[municipalityKey]) {
        target[districtKey] = "";
        return;
      }

      target[districtKey] = "";
    },
    syncLocationFromDistrict(target, countryKey, departmentKey, municipalityKey, districtKey) {
      if (!target) return;
      if (!this.isElSalvadorCountry(target[countryKey])) {
        target[departmentKey] = "00";
        target[municipalityKey] = "00";
        target[districtKey] = "00";
        return;
      }

      const district = this.getDistrictByCode(target[districtKey]);
      if (!district) return;

      target[departmentKey] = district.Departamento || district.Department || "00";
      target[municipalityKey] = district.Municipio || district.Municipality || "00";
    },
    resetNonSalvadorLocation(target, departmentKey, municipalityKey, districtKey) {
      if (!target) return;
      target[districtKey] = "";
    },
  },
};
